import type { IDropdownProps } from "@similarweb/ui-components";
import { Dropdown } from "@similarweb/ui-components";
import "./FiltersBarDropdown.scss";
import type { FC } from "react";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

/**
 * Wrapper for ordinary dropdown component
 * @param {IDropdownProps<any> & {children?: React.ReactNode}} props
 * @returns {any}
 * @constructor
 */
export const FiltersBarDropdown: FC<Omit<IDropdownProps<any>, "noResultsMessage">> = ({
    cssClassContainer = "",
    ...props
}) => {
    const t = useTranslation();
    const newProps = {
        ...props,
        cssClassContainer: `${cssClassContainer} DropdownContent-container FiltersBarDropdown`,
        noResultsMessage: t("dropdown.no.results"),
    };
    return <Dropdown {...newProps} />;
};

FiltersBarDropdown.displayName = "FiltersBarFilter";
